import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_green-properties-crt/artifacts/4twghzfk_LOGO%20GREEHOUSE-def.pdf%20%282%29.png";
const REGGIA_IMAGE = "https://images.unsplash.com/photo-1767460775150-24c978b49421?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxSZWdnaWElMjBkaSUyMENhc2VydGElMjBmYWNhZGUlMjByb3lhbCUyMHBhbGFjZXxlbnwwfHx8fDE3NzY1MDYwMzR8MA&ixlib=rb-4.1.0&q=85";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="relative text-white">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img src={REGGIA_IMAGE} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img src={LOGO_URL} alt="Green House" className="h-16 w-auto brightness-0 invert" />
            <p className="font-sans text-sm text-white/80 leading-relaxed">
              Servizi Immobiliari dal 2011. La tua casa ideale è a un passo.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/greenhousesrl"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/greenhouse_caserta"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-xl mb-6">Link Utili</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/properties" className="font-sans text-sm text-white/80 hover:text-white transition-colors">
                  Annunci in Vendita
                </Link>
              </li>
              <li>
                <Link to="/services" className="font-sans text-sm text-white/80 hover:text-white transition-colors">
                  I Nostri Servizi
                </Link>
              </li>
              <li>
                <Link to="/sell" className="font-sans text-sm text-white/80 hover:text-white transition-colors">
                  Vendi Casa
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-sans text-sm text-white/80 hover:text-white transition-colors">
                  Chi Siamo
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-xl mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="font-sans text-sm text-white/80">
                  Via Caduti sul Lavoro n.49<br />81100 Caserta (CE), Italia
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+3908231848006" className="font-sans text-sm text-white/80 hover:text-white">
                  0823 1848006
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:info@greenhousecaserta.it" className="font-sans text-sm text-white/80 hover:text-white">
                  info@greenhousecaserta.it
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-serif text-xl mb-6">Orari</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Clock size={18} className="mt-1 flex-shrink-0" />
                <div className="font-sans text-sm text-white/80">
                  <p>Lun - Ven: 09:00 - 13:00 / 15:30 - 20:00</p>
                  <p>Sabato: 09:00 - 13:00</p>
                  <p>Domenica: Chiuso</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Info */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="font-sans text-xs text-white/50 space-y-1">
              <p><strong className="text-white/70">Ragione Sociale:</strong> Green House s.r.l.</p>
              <p><strong className="text-white/70">P.Iva / C.F:</strong> 03689880619</p>
              <p><strong className="text-white/70">R.E.A.:</strong> 264321</p>
            </div>
            <div className="flex flex-col md:items-end justify-center space-y-2">
              <p className="font-sans text-sm text-white/60">
                © {new Date().getFullYear()} Green House Servizi Immobiliari. Tutti i diritti riservati.
              </p>
              <div className="flex flex-wrap items-center gap-3 pb-20 md:pb-0 md:justify-end" data-testid="legal-links">
              <a
                href="https://www.iubenda.com/privacy-policy/84083459"
                className="iubenda-white iubenda-noiframe iubenda-embed"
                title="Privacy Policy "
                data-testid="privacy-link"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/84083459/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed"
                title="Cookie Policy "
                data-testid="cookie-policy-link"
              >
                Cookie Policy
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
